import type { AxiosError } from "axios";
import useSWR from "swr";
import type { NskSwrErrorResponse, SwrReturnType } from "~/models/Api";
import type { DealWorkflow } from "~/models/DealWorkflow";
import { generatePath } from "~/utils/generatePath";

const paths = {
	index: "/deals/:deal_id/deal_workflows"
} as const;

export const useDealWorkflows = (
	dealId: number,
	onError: (error: AxiosError<NskSwrErrorResponse>) => void
): SwrReturnType<DealWorkflow[]> => {
	const { data, mutate, error, isLoading } = useSWR<DealWorkflow[]>(
		generatePath(paths.index, { deal_id: dealId }),
		{ onError, shouldRetryOnError: false }
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
